import { render } from "./InventarioDetalhes.vue?vue&type=template&id=69b9c766&scoped=true"
import script from "./InventarioDetalhes.vue?vue&type=script&lang=js"
export * from "./InventarioDetalhes.vue?vue&type=script&lang=js"

import "./InventarioDetalhes.vue?vue&type=style&index=0&id=69b9c766&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b9c766"]])

export default __exports__